module.exports = __webpack_public_path__ + "assets/videocall.70577c0c.png";